import React, { useState } from "react";
import logo from "../../assets/app_logo.png";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import Button from "../UI/Button";
import { Link } from "react-router-dom";
import { StyledAuthSection, StyledLogo, StyledForm, StyledBacktoLogin, StyledLoginButton } from "./styles";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { useFormik } from "formik";
import { ResetPasswordValidationSchema } from "./helpers/schema";
import { useAuth } from "./hooks/useAuth";
import { PasswordResetConfirmation } from "../PasswordResetConfirmation";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
const ResetPasswordForm = () => {
  const { isLoading, isError: errorMessage, resetPassword } = useAuth();
  const [isResetDone, setIsResetDone] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      secretPin: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: ResetPasswordValidationSchema,
    onSubmit: (values) => {
      resetPassword(values).then((res) => {
        if (res && typeof res === "object" && res.StatusCode === 200) {
          setIsResetDone(true);
        }
      });
    },
  });
  const { confirmPassword, email, password, secretPin } = formik.values;

  return (
    <StyledAuthSection className="tma_login_form_wrapper">
      <div className="tma_logo_container">
        <StyledLogo src={logo} alt="tma_app_logo" className="tma_app_logo" />
      </div>
      <div className="tma_login_content">
        <h1 className="tma_form_title">{translate("labels.resetPassword")}</h1>
        <StyledForm
          className="tma_auth_form tma_restPass_form"
          onSubmit={formik.handleSubmit}
        >
          <div className="tma_form_control">
            <Input
              id="email"
              type="email"
              name="email"
              placeholder={translate("labels.enterYourEmail")}
              value={email}
              labelText={translate("labels.email")}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </div>
          <div className="tma_form_control tma_form_resetcontrol">
            <Input
              id="secretPin"
              type="password"
              name="secretPin"
              placeholder={translate("labels.tempPin")}
              labelText={translate("labels.tempPassword")}
              showInfoToolTip={true}
              tooltipText={translate("labels.tempPasswordInfo")}
              value={secretPin}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.secretPin && Boolean(formik.errors.secretPin)}
              helperText={formik.touched.secretPin && formik.errors.secretPin}
            />
          </div>
          <div className="tma_form_control">
            <Input
              id="password"
              type="password"
              name="password"
              placeholder={"********"}
              labelText={translate("labels.newPassword")}
              showInfoToolTip={false}
              value={password}
              inputProps={{ maxLength: 100 }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
            />
          </div>
          <div className="tma_form_control">
            <Input
              id="confirmPassword"
              type="password"
              name="confirmPassword"
              placeholder={"********"}
              labelText={translate("labels.confirmPassword")}
              showInfoToolTip={false}
              value={confirmPassword}
              inputProps={{ maxLength: 100 }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.confirmPassword &&
                Boolean(formik.errors.confirmPassword)
              }
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
            />
          </div>
          <StyledBacktoLogin>

            <KeyboardBackspaceIcon />
            <Link to={SITE_LINKS_SCHEMA.LOGIN}>
              {translate("labels.backToLogin")}
            </Link>

          </StyledBacktoLogin>
          <div className="tma_form-feedback">
            {errorMessage && <p className="tma_error">{errorMessage}</p>}
          </div>
          <div className="tma_form_action">

            <StyledLoginButton>
              <Button
                isLoading={isLoading}
                text={translate("labels.resetPassword")}
                type="submit"
              />
            </StyledLoginButton>

          </div>
        </StyledForm>
        {isResetDone && (
          <PasswordResetConfirmation
            forEmail={email}
            onClose={() => setIsResetDone(false)}
          />
        )}
      </div>
    </StyledAuthSection>
  );
};

export { ResetPasswordForm };
